// extracted by mini-css-extract-plugin
export default {"cls1":"ethn2dfOdkWMWYptgFlf","cls2":"gk5c0LY5w4nBn3__lp4F ethn2dfOdkWMWYptgFlf"};